import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";

// TikTok icon component
const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
  </svg>
);

export const Footer = () => {
  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-[#7C2C3B] flex items-center justify-center">
                <span className="text-white font-bold text-xl" style={{ fontFamily: 'Barlow Condensed' }}>ALL</span>
              </div>
              <div>
                <h3 className="font-bold text-lg" style={{ fontFamily: 'Barlow Condensed' }}>ALL WHUFC</h3>
                <p className="text-sm text-gray-400">Forever Blowing Bubbles</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              The ultimate destination for West Ham United fans. Join our family and celebrate the Hammers together.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wide mb-4 text-[#2BAEE5]">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/fixtures" className="text-gray-400 hover:text-white text-sm transition-colors">Fixtures & Results</Link></li>
              <li><Link to="/history" className="text-gray-400 hover:text-white text-sm transition-colors">Club History</Link></li>
              <li><Link to="/players" className="text-gray-400 hover:text-white text-sm transition-colors">Player Profiles</Link></li>
              <li><Link to="/cups" className="text-gray-400 hover:text-white text-sm transition-colors">Cup Competitions</Link></li>
              <li><Link to="/entertainment" className="text-gray-400 hover:text-white text-sm transition-colors">Entertainment</Link></li>
              <li><Link to="/forum" className="text-gray-400 hover:text-white text-sm transition-colors">Fan Forum</Link></li>
            </ul>
          </div>

          {/* Membership */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wide mb-4 text-[#2BAEE5]">Membership</h4>
            <ul className="space-y-2">
              <li><Link to="/register" className="text-gray-400 hover:text-white text-sm transition-colors">Join Now</Link></li>
              <li><Link to="/login" className="text-gray-400 hover:text-white text-sm transition-colors">Member Login</Link></li>
              <li><Link to="/profile" className="text-gray-400 hover:text-white text-sm transition-colors">My Account</Link></li>
            </ul>
            <div className="mt-6 p-4 bg-[#7C2C3B]/20 rounded-lg border border-[#7C2C3B]/30">
              <p className="text-sm text-gray-300">Join All WHUFC for exclusive content and community access!</p>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wide mb-4 text-[#2BAEE5]">Connect</h4>
            <div className="flex gap-3 mb-6">
              <a 
                href="https://www.instagram.com/allwhufc" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 flex items-center justify-center hover:opacity-80 transition-opacity" 
                aria-label="Instagram @allwhufc"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://www.tiktok.com/@allwhufc" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-black flex items-center justify-center hover:bg-gray-800 transition-colors" 
                aria-label="TikTok @allwhufc"
                data-testid="social-tiktok"
              >
                <TikTokIcon className="w-5 h-5" />
              </a>
            </div>
            <p className="text-gray-400 text-sm mb-4">Follow us @allwhufc</p>
            <div className="space-y-2">
              <a href="mailto:infowhufc@gmail.com" className="flex items-center gap-2 text-gray-400 hover:text-white text-sm transition-colors">
                <Mail className="w-4 h-4" />
                infowhufc@gmail.com
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-10 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} All WHUFC. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link 
              to="/faq" 
              className="text-gray-400 hover:text-white text-sm transition-colors"
              data-testid="footer-faq-link"
            >
              FAQ
            </Link>
            <Link 
              to="/on-this-day" 
              className="text-gray-400 hover:text-white text-sm transition-colors"
              data-testid="footer-otd-link"
            >
              On This Day
            </Link>
            <Link 
              to="/chants" 
              className="text-gray-400 hover:text-white text-sm transition-colors"
              data-testid="footer-chants-link"
            >
              Chants
            </Link>
            <Link 
              to="/admin" 
              className="text-gray-600 hover:text-gray-400 text-xs transition-colors"
              data-testid="footer-admin-link"
            >
              Admin
            </Link>
          </div>
        </div>
        <div className="mt-4 text-center">
          <p className="text-gray-600 text-xs">
            Not affiliated with West Ham United FC. A fan-run community.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
